import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/Calcolatrice3D.png'


const _hoisted_1 = { class: "forfettario-welcome-card bg-hero-primary smartrate-card border-radius d-block border-0 shadow-none pb-0" }
const _hoisted_2 = { class: "smartrate-card-content px-4 pt-3 pb-5" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-7" }
const _hoisted_5 = { class: "content" }
const _hoisted_6 = { class: "mb-0 fw-normal text-white" }
const _hoisted_7 = { class: "text-danger-div" }
const _hoisted_8 = { class: "d-block fw-medium" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h1", _hoisted_6, [
              _createTextVNode(_toDisplayString(_ctx.t('ff.welcome.message_line1_part1', 'La tua')) + " ", 1),
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.t('ff.welcome.message_line1_part2', 'rata ideale')), 1),
              _createTextVNode(" " + _toDisplayString(_ctx.t('ff.welcome.message_line1_part3', 'è solo l\'inizio del viaggio.')), 1)
            ]),
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.t('ff.welcome.message_line2', 'Usa il nostro tool per fare il primo passo verso un futuro in cui le tasse si gestiscono in modo più smart.')), 1)
          ])
        ]),
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "col-md-5 d-none d-md-block" }, [
          _createElementVNode("div", {
            class: "image",
            style: {"position":"relative"}
          }, [
            _createElementVNode("img", {
              src: _imports_0,
              alt: "Calcolatrice 3D",
              class: "calculator-image"
            })
          ])
        ], -1))
      ])
    ])
  ]))
}